import ContractPeriod from "../../../utils/services/project/accounting/contractPeriodService";
import crudTemplate from "../../../templates/crudTemplate";
import rolesTemplate from "../../../templates/rolesTemplate";
import contactStore from "../../contactStore";
import i18n from "../../../../plugins/i18n";
let crud = crudTemplate(ContractPeriod);
let roles = rolesTemplate(ContractPeriod);
function prepareItem(i) {
  i.cost_centre_name = i._cost_centre && i._cost_centre.name;
  i.cost_centre_id = i._cost_centre && i._cost_centre.id;
  let contact = contactStore.prepareContact(i._contact);
  i.contact_name = contact && contact.compiledName;
  i.contact_id = contact && contact.id;
  i.set_group_authorization_text = i.set_group_authorization
    ? i18n.t("groups.yes")
    : i18n.t("groups.no");
  return i;
}
const state = {
  ...crud.state,
  ...roles.state
};
const getters = {
  ...crud.getters,
  ...roles.getters,
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  ...roles.actions,
  getList(state, { params = {}, onSuccess = () => {} }) {
    params.orders =
      params.orders &&
      params.orders.replace("cost_centre_name", "cost_centre_id");
    return crud.actions.getList(state, { params, onSuccess });
  },
  create(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item._cost_centre = { id: item.cost_centre_id };
    item._contact = { id: item.contact_id };
    if (!item.start_date) delete item.start_date;
    if (!item.end_date) delete item.end_date;
    return crud.actions.create(_, {
      item,
      errorHandler,
      onSuccess
    });
  },
  update(_, { item, errorHandler = () => {}, onSuccess = () => {} }) {
    item._cost_centre = { id: item.cost_centre_id };
    item._contact = { id: item.contact_id };
    return crud.actions.update(_, {
      item,
      errorHandler,
      onSuccess
    });
  }
};

const mutations = {
  ...crud.mutations,
  ...roles.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
